import React from "react";

import { buttonPrimary } from "css";

export const BlankButton = ({ appointment }) => {
  return (
    <>
      <div className="justify-self-start w-full md:w-1/4">
        <div
          className={`${buttonPrimary} cursor-pointer`}
          style={{
            backgroundColor: "none",
            boxShadow: "none",
            border: "0px",
          }}
        >
          <div className="justify-self-center"></div>
          <div className="text-right w-1/2"></div>
        </div>
      </div>
    </>
  );
};
